import { render } from "./AtendimentoView.vue?vue&type=template&id=01d155b7&scoped=true"
import script from "./AtendimentoView.vue?vue&type=script&lang=js"
export * from "./AtendimentoView.vue?vue&type=script&lang=js"

import "./AtendimentoView.vue?vue&type=style&index=0&id=01d155b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d155b7"]])

export default __exports__